import { createContext, useContext, useState, useCallback, useMemo, useEffect } from 'react';

const PageContext = createContext(null);

export function PageProvider({ children }) {
  const [meta, setMeta] = useState({});

  const setPageMeta = useCallback((next) => {
    setMeta(next || {});
  }, []);

  const value = useMemo(() => ({ meta, setPageMeta }), [meta, setPageMeta]);

  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
}

export function usePageMeta(factory, deps = []) {
  const ctx = useContext(PageContext);
  const setPageMeta = ctx?.setPageMeta;

  useEffect(() => {
    if (!setPageMeta) return;
    setPageMeta(factory?.() || {});
    return () => setPageMeta({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export function usePageContext() {
  return useContext(PageContext) || { meta: {}, setPageMeta: () => {} };
}
